// extracted by mini-css-extract-plugin
var _1 = "Subject-modulesubject__UXUGZ";
var _2 = "Subject-modulesubjectWrapper__gxQFN";
var _3 = "Subject-moduletext__iWeKR EmailProfileRaw-moduletext__prNIu";
export { _1 as "subject", _2 as "subjectWrapper", _3 as "text" }
